import React, { memo } from "react";
import { useGameTitle } from "./index.hooks";
import { Box, Stack, Typography } from "@mui/material";

type GameTitleProps = {};

export const GameTitle = memo(({}: GameTitleProps) => {
  const { sxTitleProps, gameWon, chosenLevel } = useGameTitle();

  return (
    <Box
      sx={{
        color: "white",
        textAlign: {
          xs: "center",
          md: "left",
        },
        "& *": {
          lineHeight: {
            xs: "1.2!important",
            md: "1.3!important",
          },
        },
      }}
    >
      {gameWon ? (
        <Stack spacing={2}>
          <Typography
            sx={{
              fontWeight: "bolder",
              color: "#FFCB00",
              ...sxTitleProps,
            }}
          >
            OTTIMO LAVORO!
          </Typography>
          <Typography fontWeight={300} sx={sxTitleProps}>
            {chosenLevel.successDialogContent.subtitle}
          </Typography>
        </Stack>
      ) : (
        <>
          <Typography
            sx={{ fontWeight: "bolder", ...sxTitleProps }}
            display="inline"
          >
            Ricomponi{" "}
          </Typography>
          <Typography fontWeight={300} sx={sxTitleProps} display="inline">
            il puzzle e{" "}
          </Typography>
          <Typography
            sx={{ fontWeight: "bolder", ...sxTitleProps }}
            display="inline"
          >
            ricostruisci{" "}
          </Typography>
          <Typography fontWeight={300} sx={sxTitleProps} display="inline">
            l’immagine dell’opera.
          </Typography>
        </>
      )}
    </Box>
  );
});
